export default "__VITE_ASSET__BFUmBL7M__"